// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"352184be","417":"0ad5441b","453":"ac8ececf"}[chunkId] + ".chunk.js";
};